(() => {
  let cartRequest;
  function readCart() {
    if (!cartRequest) {
      const root = window.Shopify?.routes?.root || '/';
      cartRequest = fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(response => {
          if (!response.ok) throw new Error('CART_UNAVAILABLE');
          return response.json();
        })
        .then(cart => {
          if (!Array.isArray(cart.items)) throw new Error('CART_INVALID');
          return cart;
        })
        .finally(() => { cartRequest = undefined; });
    }
    return cartRequest;
  }

  class QuantityReview extends HTMLElement {
    connectedCallback() {
      try {
        this.options = JSON.parse(this.querySelector('[data-csq-options]').textContent);
      } catch {
        return;
      }
      this.version = 0;
      this.list = this.querySelector('[data-csq-issues]');
      this.caveat = this.querySelector('[data-csq-caveat]');
      this.status = this.querySelector('[data-csq-status]');
      this.form = this.options.mode === 'product' ? document.getElementById(this.options.formId) : null;
      this.onInput = () => this.refresh(this.lastCart);
      if (this.form) {
        this.form.addEventListener('input', this.onInput);
        this.form.addEventListener('change', this.onInput);
      }
      this.onExternalInput = event => {
        if (event.target.form === this.form && this.form && !this.form.contains(event.target)) this.refresh(this.lastCart);
      };
      document.addEventListener('input', this.onExternalInput);
      document.addEventListener('change', this.onExternalInput);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }
      this.refresh({ items: this.options.items });
      if (this.options.mode === 'product') this.refresh();
    }

    disconnectedCallback() {
      this.version++;
      this.unsubscribe?.();
      if (this.form) {
        this.form.removeEventListener('input', this.onInput);
        this.form.removeEventListener('change', this.onInput);
      }
      document.removeEventListener('input', this.onExternalInput);
      document.removeEventListener('change', this.onExternalInput);
    }

    selectedLine() {
      if (!this.form) return null;
      const data = new FormData(this.form);
      const properties = {};
      for (const [key, value] of data) {
        const match = /^properties\[(.+)\]$/.exec(key);
        if (!match) continue;
        if (typeof value === 'string') properties[match[1]] = value;
        else if (value.size) properties[match[1]] = `selected:${value.name}:${value.size}:${value.lastModified}`;
      }
      const names = window.CSQuantityModel.propertyNames;
      const source = properties[names.SOURCE];
      const fixedDesign = this.options.catalog[String(this.options.productId)]?.designMode === 'fixed';
      const incompleteSelection = !fixedDesign && (!source || (source === 'CanSweet archive / Archives CanSweet' && !properties[names.REFERENCE]?.trim()) ||
          (source === 'Customer image / Image du client' && !properties[names.FILE]?.trim() && !properties[names.LEGACY_IMAGE]?.trim()));
      return { lineKey: '__csq_selection__', productId: this.options.productId, variantId: data.get('id'),
        quantity: Number(data.get('quantity') || 1), properties, title: this.options.productTitle, incompleteSelection };
    }

    async refresh(cart) {
      const version = ++this.version;
      try {
        cart = cart || await readCart();
        if (!this.isConnected || this.version !== version) return;
        this.lastCart = cart;
        this.querySelector('[data-csq-rule]').hidden = this.options.mode !== 'product' &&
          !cart.items.some(item => this.options.catalog[String(item.product_id)]);
        const model = window.CSQuantityModel;
        if (!model) throw new Error('MODEL_UNAVAILABLE');
        const lines = model.cartLines(cart);
        let selection;
        if (this.options.mode === 'product') {
          selection = this.selectedLine();
          if (!selection) {
            this.render([]);
            return;
          }
          if (selection.incompleteSelection) {
            const variant = this.options.catalog[String(selection.productId)]?.variants[String(selection.variantId)];
            if (!variant || !Number.isSafeInteger(selection.quantity) || selection.quantity < 1) {
              this.render([{ kind: 'unavailable' }]);
            } else if (selection.quantity < 12) {
              this.render([{ kind: 'below_minimum', title: selection.title, descriptor: variant.descriptor,
                quantity: selection.quantity, minimum: 12, missing: 12 - selection.quantity }]);
            } else {
              this.render([]);
            }
            return;
          }
          lines.push(selection);
        }
        const result = model.inspectBatches(lines, this.options.catalog, 12);
        const issues = this.options.mode === 'product'
          ? result.issues.filter(issue => issue.lineKeys.includes(selection.lineKey)) : result.issues;
        this.render(issues);
      } catch {
        if (!this.isConnected || this.version !== version) return;
        this.render([{ kind: 'unavailable' }]);
      }
    }

    render(issues) {
      this.list.replaceChildren();
      for (const issue of issues) {
        const item = document.createElement('li');
        const title = issue.title ? `${issue.title}${issue.descriptor ? ` (${issue.descriptor})` : ''}: ` : '';
        let message = this.options.strings.review;
        if (issue.kind === 'below_minimum') {
          message = this.options.strings.shortage.replace('[quantity]', issue.quantity)
            .replace('[minimum]', issue.minimum).replace('[missing]', issue.missing);
        }
        item.textContent = title + message;
        this.list.appendChild(item);
      }
      this.list.hidden = issues.length === 0;
      this.caveat.hidden = !issues.some(issue => issue.kind === 'below_minimum');
      this.status.textContent = '';
      this.dataset.needsReview = String(issues.length > 0);
    }
  }
  if (!customElements.get('cansweet-quantity-review')) customElements.define('cansweet-quantity-review', QuantityReview);
})();
